var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadCsv = function SvgDownloadCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 4.69317C12.4467 2.39317 10.4267 0.666504 8 0.666504C6.07333 0.666504 4.4 1.75984 3.56667 3.35984C1.56 3.57317 0 5.27317 0 7.33317C0 9.53984 1.79333 11.3332 4 11.3332H12.6667C14.5067 11.3332 16 9.83984 16 7.99984C16 6.23984 14.6333 4.81317 12.9 4.69317ZM6.66667 6.06044V3.33317H9.33333V6.06044H11.3333L8.23333 9.2309C8.1 9.36726 7.89333 9.36726 7.76 9.2309L4.66667 6.06044H6.66667Z"
  })));
};
export default SvgDownloadCsv;